import React, { ReactNode } from 'react'

const isReactElement = (item: ReactNode): boolean => {
  return React.isValidElement(item)
}
export default isReactElement
